export default function SidebarItem({
    icon,
    label,
    value,
}) {
    return (
        <div className="flex items-center justify-between gap-4 border-b border-slate-100 pb-3 last:border-0 last:pb-0">

            <div className="flex items-center gap-3">

                <div className="text-gray-400">
                    {icon}
                </div>

                <span className="text-sm text-slate-500">
                    {label}
                </span>

            </div>

            <span className="truncate text-right text-sm font-semibold text-slate-900">
                {value || "-"}
            </span>

        </div>
    );
}
